module.exports = __webpack_public_path__ + "static/media/dineInLunch.1c9b5ab3.pdf";